import { Row } from 'reactstrap';

export default Row;
